import PhoneIcon from '@mui/icons-material/Phone';
import React from 'react';

import { isPhoneCallCompletedError } from '_lib/api/apiTypes.shim';
import { useCallLogNavigate } from '_lib/callPop/useCallLogNavigate';
import { Button } from '_lib/components/Button/Button';

type CompleteCallWrapperProps = {
  nonFieldErrors: string[];
  children: React.ReactNode;
};

export const CompleteCallWrapper = (props: CompleteCallWrapperProps): React.ReactElement => {
  const { navigateToCallLog } = useCallLogNavigate();

  if (!isPhoneCallCompletedError({ nonFieldErrors: props.nonFieldErrors })) {
    return <>{props.children}</>;
  } else {
    return (
      <Button color='primary' fullWidth onClick={navigateToCallLog} startIcon={<PhoneIcon />} variant='contained'>
        Call Log
      </Button>
    );
  }
};
